module.exports = "/_next/static/images/35a9d069f81d875408d8ef974f827e69-bubble-gum-woman-square@md-2x.jpg";